import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface WorkflowSearchState {
  searchFilter: string;
}

const initialState: WorkflowSearchState = {
  searchFilter: "",
};

export const workflowSearchSlice = createSlice({
  name: "workflowSearch",
  initialState,
  reducers: {
    setSearchFilter: (state, action: PayloadAction<string>) => {
      state.searchFilter = action.payload;
    },
  },
});

export const { setSearchFilter } = workflowSearchSlice.actions;

export function selectWorkflowSearchFilter(state: {
  workflowSearch: WorkflowSearchState;
}) {
  return state.workflowSearch.searchFilter;
}
